var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { disabled: _vm.disabled, icon: "" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.executeMethod()
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "span",
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.color,
                                small: _vm.cancelAutoSmall
                                  ? _vm.$vuetify.breakpoint.name != "xs"
                                  : false,
                              },
                            },
                            [_vm._v(_vm._s(_vm.icon))]
                          ),
                          _vm.textButton
                            ? _c("small", [
                                _c("br"),
                                _vm._v(_vm._s(_vm.textButton)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v(" " + _vm._s(_vm.toolTip) + " ")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }